import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BannerComponent } from 'src/app/screens/shared/banner/banner.component';
import { ButtonComponent } from 'src/app/screens/shared/button/button.component';
import { LoaderComponent } from 'src/app/screens/shared/loader/loader.component';
import { SideMenuComponent } from 'src/app/screens/shared/side-menu/side-menu.component';
import { LazyloadDirective } from 'src/app/directives/lazyload.directive';
import { SafePipe } from 'src/app/pipe/safe/safe.pipe';
import { RouterModule } from '@angular/router';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { FacultyCardComponent } from 'src/app/screens/shared/faculty-card/faculty-card.component';
import { CommonTableComponent } from 'src/app/screens/shared/common-table/common-table.component';



@NgModule({
  declarations: [
    BannerComponent,
    ButtonComponent,
    LoaderComponent,
    SideMenuComponent,
    LazyloadDirective, 
    SafePipe,
    FacultyCardComponent,
    CommonTableComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    PdfViewerModule
  ],
  exports: [
    BannerComponent,
    ButtonComponent,
    LoaderComponent,
    SideMenuComponent,
    LazyloadDirective,
    SafePipe,
    FacultyCardComponent,
    CommonTableComponent
  ]
})
export class SharedModule { }
